import { Datatype } from '../../../../datatype/Datatype';
import { createConditionOperator } from '../../IConditionOperator';

export const ConditionOperatorCountEquals = createConditionOperator({
  code: 'countEquals',
  label: 'conteggio uguale a',
  description: 'Conteggio uguale a',
  args: [{ type: 'staticValue', field: { type: Datatype.Number } }],
  allowsField: field => field.type === Datatype.Array,
  compare(value: any, [count]: readonly [number]) {
    if (count == null) return false;
    return Array.isArray(value) && value.length === count;
  },
});
